// TODO: Replace with typed router
import { useRoute, useRouter } from "vue-router";

type BreadCrumb = {
    name: string;
    path: string;
};

// eslint-disable-next-line no-restricted-exports, unicorn/no-anonymous-default-export
export default () => {
    const { t } = useI18n();

    const router = useRouter();
    const route = useRoute();

    const breadcrumbs: Ref<BreadCrumb[] | undefined> = ref();

    watchEffect(() => {
        if (route.path === "/") return;

        breadcrumbs.value = getBreadcrumbs(route.path);
    });

    function getBreadcrumbs(currentPath: string): BreadCrumb[] {
        if (currentPath === "") return [{ name: "", path: "" }];

        const parentRoutes = getBreadcrumbs(
            currentPath.slice(0, currentPath.lastIndexOf("/")),
        );

        const route = router.resolve(currentPath);

        const name = ref<string>("");

        if (route.meta.displayName) {
            name.value = t(
                route.meta.displayName,
                route.meta.pluralName ? 2 : 1,
            );

            if ("id" in route.params && route.meta.hasDisplayId) {
                name.value += ` #${String(route.params.id)}`;
            }
        } else {
            name.value = "";
        }

        return [
            ...parentRoutes,
            {
                name: name.value,
                path: currentPath,
            },
        ];
    }

    return {
        breadcrumbs,
    };
};
